import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  logIn: () => i18n.t(i18nKeys.common__logIn),
}
